import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleapisService {
  private loadAPI: Promise<any>;

  constructor() {
  }

  public loadScript() {
    const dynamicScripts = [
      'https://apis.google.com/js/api.js'
    ];

    for (const script of dynamicScripts) {
      const node = document.createElement('script');
      node.src = script;
      node.type = 'text/javascript';
      node.async = true;
      node.defer = true;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  isApiLoaded(): boolean {
    return (window as any).gapi ? true : false;
  }

  loadApi() {
    this.loadScript();

    return this.loadAPI = new Promise((resolve) => {
        (window as any).gapi_onload = _ => {
            resolve(true);
        };
    });
  }
}
